import { Component } from '@angular/core';
import { appSettings } from 'app/appSettings';
import { StockCountSandbox } from 'app/core/sandboxes/stock-count.sandbox';
import { CustomerInfo } from 'app/core/store/customer-info/customer-info.interface';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { StockCountDetail, StockCountPacking, StockCountState } from 'app/core/store/stock-count/stock-count.interface';
import { BaseContainer } from 'app/modules/base/BaseContainer';
import { util } from '../../../core/util/util';
import { distinctUntilChanged, map, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'stock-count-detail',
  templateUrl: './stock-count-detail.component.html',
  styleUrls: ['./stock-count-detail.component.scss'],
})
export class StockCountDetailComponent extends BaseContainer {
  dateFormat: string = appSettings.DATE_FORMAT_ANGULAR;
  stockCount: StockCountDetail = null;
  definitions: Definitions = null;
  shipTos: Definition[] = [];

  constructor(private sandbox: StockCountSandbox) {
    super();

    this.store
      .select('stockCount')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((stockCount: StockCountState) => ({
          detail: stockCount.detail,
        })),
        distinctUntilChanged()
      )
      .subscribe(({ detail }) => {
        this.stockCount = detail.data;
      });

    this.store
      .select('definitions')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((def: Definitions) => ({
          def,
        })),
        distinctUntilChanged()
      )
      .subscribe(({ def }) => {
        this.definitions = def;
      });

    this.store
      .select('customerInfo')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((customerInfo: CustomerInfo) => ({
          shipTos: customerInfo.customer ? customerInfo.customer.shipTos : null,
        })),
        distinctUntilChanged()
      )
      .subscribe(({ shipTos }) => {
        if (shipTos) {
          this.shipTos = shipTos;
        }
      });
  }

  findPackingId(id: StockCountPacking): string {
    if (id && this.definitions) {
      const packing = this.definitions.packing.type.find(packing => packing.id === id.packingID);
      return packing && packing.name ? packing.name : '';
    } else {
      return '';
    }
  }

  backClicked() {
    this.sandbox.cancelCreate();
  }

  mapToOrFrom(id: string) {
    const shipto = this.shipTos.find(shipto => util.toNumber(shipto.id) === util.toNumber(id));
    return shipto && shipto.name ? shipto.name : '';
  }
}
